import React from "react";
import styled from "styled-components";
import { FormattedMessage } from "react-intl";

import Widget from "./Widget";
import Box from "../Box";

const QuizWrapper = styled(Box)``;

const RadioMatrix = props => (
  <QuizWrapper>
    {props.quiz ? (
      <Widget
        {...props}
        onSelected={(itemId, optionId) =>
          props.onMultipleSelected(itemId, optionId)
        }
        onSubmit={() => props.onSubmit()}
        dynamicContent={props.children}
      />
    ) : (
      <FormattedMessage id="globals.loading" />
    )}
  </QuizWrapper>
);

export default RadioMatrix;
